import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/imacuser/Downloads/silk_export/src/app/for-buyers/components/ForBuyersInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/imacuser/Downloads/silk_export/src/components/common/Header.tsx");
